import { render } from "./select.vue?vue&type=template&id=1a5ccac2"
import script from "./select.vue?vue&type=script&lang=js"
export * from "./select.vue?vue&type=script&lang=js"

import "./select.vue?vue&type=style&index=0&id=1a5ccac2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-detail-info/_components/select.vue'],['render',render],['__file',"select.vue"]])

export default __exports__